import React from "react";
import {useDispatch, connect} from 'react-redux';
import { Paper } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupIcon from '@mui/icons-material/Groups';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../images/elkh_logo.png';
import logo10gen from '../images/10gen_logo.png';

const mapStateToProps = (state) => {
    return {
        map: state.MapReducer
    }
}

const AttribPanel = (props) => {
    const dispatch = useDispatch();

    const [showPanel, setShowPanel] = React.useState(false);

    return <div>
    {
        !showPanel?(
            <IconButton style={{color: 'gray'}} onClick={()=>{setShowPanel(true)}} aria-label="delete">
                <GroupIcon />
            </IconButton>):''
    }

    <Paper elevation={10} style={{padding: 10, minWidth: 150, display:showPanel?'block':'none', paddingLeft: 16, paddingRight:16, maxHeight: 'calc(100vh - 90px)', overflowY: 'auto', borderRadius:10, backgroundColor:'#f0f0f0'}}>
        <IconButton style={{color:'gray', float:'right', marginRight:-8, marginTop:-8}} onClick={()=>{setShowPanel(false)}} aria-label="delete">
            <CloseIcon style={{width:20}} />
        </IconButton>

        <span>
            <h2>Contribution</h2>
            <p>The development was supported by the ELKH Proof of Concept 2021 tender (project manager: <a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="mailto:demetergg@gmail.com">Gábor Demeter</a>), the HAS RCH Lendület "Ten Generations" (project manager: <strong>Gergely Krisztián Horváth</strong>) and the NKFIH (OTKA K 111 766).</p>
            <p><img src={logo} style={{height:40}} alt="ELKH logo" /><img src={logo10gen} style={{height:40}} alt="10 generáció logo" /></p>
            <p>Web development:<br /><a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="https://allum.digital/" target="_blank">Allum Digital</a></p>
            <p>The base maps were created by<br /><strong>Gábor Németh</strong><br />within the framework of the project NKFI 132723, "Square cadaster": Cadaster of the mapping and documentary material of the Hungarian cadastral survey, 1850–1918, managed by<br /><strong>T. Csaba Reisz</strong></p>
            <p>Project manager (GISta Hungarorum, OTKA K 111 766):<br /><a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="mailto:demetergg@gmail.com">Gábor Demeter</a></p>
            <p>Grid maps developed by<br /><strong>István Papp</strong></p>
            <p>Contributors:<br />
            <strong>Norbert Apáti</strong>,<br />
            <strong>Róbert Bagdi</strong>,<br />
            <strong>Roland Balassa</strong>,<br />
            <strong>Gergely Károly Bán</strong>,<br />
            <strong>Viktória Benedek</strong>,<br />
            <strong>Zsolt Bottlik</strong>,<br />
            <strong>Gábor Buzgó</strong>,<br />
            <strong>Loránd Csámer</strong>,<br />
            <strong>Pál Demeter</strong>,<br />
            <strong>Zsuzsanna Demeterné Németh</strong>,<br />
            <strong>Tamás Faragó</strong>,<br />
            <strong>Zoltán Fónagy</strong>,<br />
            <strong>Zsuzsa Frisnyák</strong>,<br />
            <strong>Brigitta Gyenge</strong>,<br />
            <strong>Erika Győri</strong>,<br />
            <strong>Anna Haiser</strong>,<br />
            <strong>István Hegedűs</strong>,<br />
            <strong>Dominik Herka</strong>,<br />
            <strong>Szabolcs Holb</strong>,<br />
            <strong>Tibor Kóti</strong>,<br />
            <strong>Mónika Máté</strong>,<br />
            <strong>Mariann Nagy</strong>,<br />
            <strong>Richárd Nagy</strong>,<br />
            <strong>Vince I. Nagy</strong>,<br />
            <strong>Ágnes Pálóczi</strong>,<br />
            <strong>Gergő Papp</strong>,<br />
            <strong>János Pénzes</strong>,<br />
            <strong>Zsolt Radics</strong>,<br />
            <strong>Dávid Sebestyén</strong>,<br />
            <strong>László Simkó</strong>,<br />
            <strong>Ágnes Szilágyiné Kővári</strong>,<br />
            <strong>Zsolt Szilágyi</strong>,<br />
            <strong>János Szulovszky</strong>,<br />
            <strong>Zoltán Túri</strong>,<br />
            <strong>Zsófia Vajda</strong>,<br />
            <strong>Barbara Vígh</strong></p>

        </span>

    </Paper>
    </div>
}

export default connect(mapStateToProps)(AttribPanel);